// CUIT del registro: se guarda solo con números y se muestra como 20-31684728-6.

export const soloDigitos = (s) => String(s || '').replace(/\D/g, '');

/** "20316847286" → "20-31684728-6", también a medida que se escribe. */
export function formatearCuit(s) {
    const d = soloDigitos(s).slice(0, 11);
    if (d.length <= 2) return d;
    if (d.length <= 10) return `${d.slice(0, 2)}-${d.slice(2)}`;
    return `${d.slice(0, 2)}-${d.slice(2, 10)}-${d.slice(10)}`;
}

/** Dígito verificador (módulo 11). El mismo cálculo que functions/src/arca/registro.js. */
export function cuitValido(cuit) {
    if (!/^\d{11}$/.test(cuit)) return false;
    const pesos = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
    const suma = pesos.reduce((total, peso, i) => total + peso * Number(cuit[i]), 0);
    const resto = 11 - (suma % 11);
    const verificador = resto === 11 ? 0 : resto === 10 ? 9 : resto;
    return verificador === Number(cuit[10]);
}
